import React from 'react';
import Layout from '../../components/Layout/Layout';
import { legalConfig } from '../../config/legal.config';
import './MentionLegales.css';

const MentionsLegales: React.FC = () => {
    return (
        <Layout>
            <section className="mentions-legales">
                <h2 className="section-title">Mentions Légales</h2>

                <div className="legal-content">
                    <div className="legal-section">
                        <h3>Propriétaire</h3>
                        <p><strong>{legalConfig.companyName}</strong></p>
                        <p>Forme juridique : {legalConfig.legalForm}</p>
                        <p>Capital social : {legalConfig.capital}</p>
                        <p>SIRET : {legalConfig.siret}</p>
                        <p>RCS : {legalConfig.rcs}</p>
                        <p>Préfecture de delivrance de la carte professionnelle : {legalConfig.prefecture}</p>
                        <p>Caisse garantie financière : {legalConfig.caisse}</p>
                        <p>Montant garantie financière : {legalConfig.montant}</p>
                        <p>Email : <a href={`mailto:${legalConfig.email}`}>{legalConfig.email}</a></p>
                        <p>Téléphone : <a href={`tel:${legalConfig.phone.replace(/\s/g, '')}`}>{legalConfig.phone}</a></p>
                    </div>

                    <div className="legal-section">
                        <h3>Hébergement</h3>
                        <p><strong>{legalConfig.host.name}</strong></p>
                        <p>{legalConfig.host.address}</p>
                        <p>Téléphone : {legalConfig.host.phone}</p>
                    </div>

                    <div className="legal-section">
                        <h3>Propriété intellectuelle</h3>
                        <p>
                            L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur
                            et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les
                            documents téléchargeables et les représentations iconographiques et photographiques.
                        </p>
                        <p>
                            La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est
                            formellement interdite sauf autorisation expresse du directeur de la publication.
                        </p>
                    </div>

                    <div className="legal-section">
                        <h3>Protection des données personnelles (RGPD)</h3>
                        <p><strong>Responsable du traitement :</strong> {legalConfig.gdpr.responsable}</p>
                        <p><strong>Contact DPO :</strong> <a href={`mailto:${legalConfig.gdpr.email}`}>{legalConfig.gdpr.email}</a></p>
                        <p>{legalConfig.gdpr.description}</p>
                        <p>
                            Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement
                            Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification,
                            de suppression et d'opposition aux données personnelles vous concernant.
                        </p>
                        <p>
                            Pour exercer ces droits, vous pouvez nous contacter par email à l'adresse suivante :
                            <a href={`mailto:${legalConfig.gdpr.email}`}> {legalConfig.gdpr.email}</a>
                        </p>
                    </div>

                    <div className="legal-section">
                        <h3>Cookies</h3>
                        <p>
                            Ce site peut utiliser des cookies pour améliorer l'expérience utilisateur. En poursuivant votre
                            navigation sur ce site, vous acceptez l'utilisation de cookies.
                        </p>
                    </div>

                    <div className="legal-section">
                        <h3>Liens hypertextes</h3>
                        <p>
                            Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres
                            ressources présentes sur le réseau Internet ne sauraient engager la responsabilité de {legalConfig.companyName}.
                        </p>
                    </div>

                    <div className="legal-section">
                        <h3>Limitation de responsabilité</h3>
                        <p>
                            {legalConfig.companyName} ne pourra être tenu responsable des dommages directs et indirects causés
                            au matériel de l'utilisateur, lors de l'accès au site, et résultant soit de l'utilisation d'un
                            matériel ne répondant pas aux spécifications indiquées, soit de l'apparition d'un bug ou d'une incompatibilité.
                        </p>
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default MentionsLegales;
